












import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportService from '@/api/CustomerImportService';
import { ECustomerImportProgressStatus } from '@/models/customer-import';

import CustomerImportWelcome from '@/componentsV2/templates/CustomerImportWelcome/CustomerImportWelcome.vue';

import {
  CustomerImportFormData,
  ECustomerImportSteps
} from '../CustomerImportModal.vue';

@Component({
  components: {
    CustomerImportWelcome
  }
})
export default class Welcome extends Vue {
  @Prop() customerImportFormData!: CustomerImportFormData;

  loading = false;
  customerImportService = new CustomerImportService();

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  handleSkipForNow() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Welcome`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Skip for now" button`
    });

    this.$emit('customer-import-event', { type: 'closeModal' });
  }

  async handleGetStarted() {
    try {
      this.loading = true;

      this.$analytics({
        eventCategory: `Import Customers Modals | Welcome`,
        eventAction: 'click',
        eventLabel: `Clicked on the "Get started" button`
      });

      await this.customerImportService.startImport(this.currentProvider.name);

      const { data } = await this.customerImportService.getImportStatus(
        this.currentProvider.name
      );

      const { status } = data;

      const eventMapper: Record<string, () => void> = {
        [ECustomerImportProgressStatus.DONE]: () => {
          this.$emit('customer-import-event', {
            type: 'goToStep',
            params: { goToStep: ECustomerImportSteps.OFFER_CREATION }
          });
        },
        [ECustomerImportProgressStatus.QUEUED]: () => {
          this.$emit('customer-import-event', {
            type: 'goToStep',
            params: { goToStep: ECustomerImportSteps.IMPORT_IN_PROGRESS }
          });
        },
        [ECustomerImportProgressStatus.PENDING]: () => {
          this.$emit('customer-import-event', {
            type: 'goToStep',
            params: { goToStep: ECustomerImportSteps.IMPORT_IN_PROGRESS }
          });
        },
        [ECustomerImportProgressStatus.IMPORTING]: () => {
          this.$emit('customer-import-event', {
            type: 'goToStep',
            params: { goToStep: ECustomerImportSteps.IMPORT_IN_PROGRESS }
          });
        }
      };

      if (eventMapper[status]) eventMapper[status]();
    } finally {
      this.loading = false;
    }
  }
}
